import Snackbar, { SnackbarProps } from '@material-ui/core/Snackbar';
import React from 'react';
import { Omit } from 'typings';
import InfoAlert from 'libs/core-components/Alert/InfoAlert/InfoAlert';
import SuccessAlert from 'libs/core-components/Alert/SuccessAlert/SuccessAlert';
import ErrorAlert from 'libs/core-components/Alert/ErrorAlert/ErrorAlert';
import Box from 'libs/core-components/Box/Box';

export type AlertType = 'error' | 'success' | 'info' | null;

type OmittedSnackBarProps = Omit<Omit<Omit<SnackbarProps, 'open'>, 'onClose'>, 'message'>;

interface FloatingAlertProps {
    onClose?: () => void;
    isOpen?: boolean;
    message: React.ReactNode;
    alertType: AlertType;
    autoHideDuration?: number;
}

export default function FloatingAlert({
    onClose = () => undefined,
    isOpen = false,
    message,
    alertType = 'info',
    autoHideDuration = 2000,
    ...props
}: FloatingAlertProps & OmittedSnackBarProps) {
    let AlertComponent;

    switch (alertType) {
        case 'info':
            AlertComponent = InfoAlert;
            break;
        case 'success':
            AlertComponent = SuccessAlert;
            break;
        case 'error':
            AlertComponent = ErrorAlert;
            break;
        default:
            AlertComponent = InfoAlert;
    }

    return (
        <Snackbar {...props} open={isOpen} onClose={onClose} autoHideDuration={autoHideDuration}>
            <Box marginY={['halfGutter', 'gutter']}>
                <AlertComponent dismissed={!isOpen} onDismiss={onClose}>
                    {message}
                </AlertComponent>
            </Box>
        </Snackbar>
    );
}
